<template>
  <footer class="clear-fix">
    <div class="footer-section">
      <div class="info">
        <a class="logo" href="/" alt="派链"></a>
        <h1 class="slogan">派链（π链）是为国内NFT/Web3/元宇宙数字资产构建的数字生态联盟区块链平台</h1>
        <p><a href="https://beian.miit.gov.cn" target="_blank">琼ICP备2022004763号-1</a></p>
        <p>&copy;2024派链CHAIN.FIRSTPI.CN</a> <a href="/static/images/license.png" target="_blank">首派公司</a> 版权所有</p>
        <p class="plice"><a href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=46010602001397"
            target="_blank"><img src="../assets/safe.png">琼公网安备46010602001397号</a></p>
      </div>
      <div class="links-wrapper">
        <div class="links">
          <p>应用场景</p>
          <a href="javascript:;">版权</a>
          <a href="javascript:;">数字藏品</a>
          <a href="javascript:;">数字身份</a>
        </div>
        <div class="links">
          <p>技术方案&产品</p>
          <a href="javascript:;">派链</a>
          <a href="javascript:;">区块浏览器</a>
          <a href="javascript:;">私钥保管</a>
        </div>
        <div class="links">
          <p>派链</p>
          <a href="javascript:;">用户协议</a>
          <a href="javascript:;">隐私政策</a>
          <a href="javascript:;">联系我们</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'page-footer',
    data() {
      return {}
    },
    methods: {}
  }
</script>
<style scoped>
  footer {
    background: #1A1A1A;
    font-size: 12px;
  }

  footer .logo {
    display: block;
  }

  footer .slogan {
    margin: 20px 0;
    font-size: 12px;
  }

  footer .footer-section {
    margin: 50px auto 0;
    max-width: 1200px;
    border-radius: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 50px 0;
  }

  footer .info p {
    color: #848895;
    margin-top: 5px;
  }

  footer .info p a {
    color: #848895;
  }

  footer .info .plice a {
    display: flex;
    align-items: center;
  }

  footer .links-wrapper {
    flex: 1;
    display: flex;
    justify-content: space-between;
    margin-left: 100px;
  }

  footer .links p {
    font-size: 16px;
  }

  footer .links a {
    display: block;
    margin-top: 20px;
    color: #848895;
  }

  @media (max-width:1199px) {
    footer .footer-section {
      width: 95% !important;
      border-radius: 10px;
      margin: 20px auto 0;
      flex-direction: column;
    }

    footer .links-wrapper {
      margin-top: 30px;
      margin-left: 0;
    }

    footer .links {
      flex: 0 1 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page-footer.vue